import { createBrowserClient } from '@supabase/ssr'
import { supabaseAnonKey, supabaseUrl } from '@/lib/env'

/**
 * The app's Supabase client. Auth only — data goes through the API.
 *
 * Cookie-backed via `@supabase/ssr`, NOT localStorage. There is no longer a
 * server to share the cookie WITH, which was the original reason, but the
 * storage is kept as it is on purpose: switching it would strand every session
 * that already exists at the moment of deploy, signing the whole userbase out
 * to gain nothing. `@supabase/ssr` is not server-only — `createBrowserClient`
 * is exactly this, a browser client that persists to cookies.
 *
 * This is also why `constellation-sdk`'s `ConstellationAPIClient` is never
 * constructed in this app: it builds its own supabase-js client with the
 * default localStorage storage, and two clients writing two different session
 * stores race each other on refresh. The SDK is imported for its request and
 * response types only.
 *
 * `createBrowserClient` memoizes internally, so calling this per component is
 * fine and there is no module-level singleton to leak between tests.
 *
 * The client refreshes the access token on its own timer. That is what replaced
 * the middleware's refresh-on-every-request, and it is a better fit for the
 * failure it was guarding: a tab backgrounded past expiry is precisely the tab
 * that issues no requests to hang a refresh off.
 */
export function createClient() {
  return createBrowserClient(supabaseUrl(), supabaseAnonKey())
}
